import cn from "classnames";
import { ChevronDown as ChevronDownIcon } from "@rshbintech.dboul/icons";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown } from "../dropdown";
import { ButtonDropdownProps } from "./types";
import styles from "./styles.module.scss";

export const ButtonDropdown = ({
  id,
  type = "primary",
  size = "medium",
  disabled = false,
  expanded = false,
  htmlType = "submit",
  items,
  dataTestId = "button-dropdown",
  className,
  children,
  onClick,
  ...otherAttributes
}: ButtonDropdownProps) => {
  const [isDropdownShown, setIsDropdownShown] = useState(expanded);
  const [dropdownWidth, setDropdownWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const isExpanded = isDropdownShown && !disabled;

  const handleResize = () => {
    setDropdownWidth(containerRef.current?.clientWidth || 0);
  };

  useEffect(() => {
    setIsDropdownShown(expanded);
  }, [expanded]);

  useEffect(() => {
    handleResize();
  }, [size]);

  useLayoutEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDropButtonClick = () => {
    setIsDropdownShown((prevIsDropdownShown) => !prevIsDropdownShown);
  };

  return (
    <div
      ref={containerRef}
      className={cn(styles.container, className)}
      data-test-id={dataTestId}
    >
      <button
        {...otherAttributes}
        id={id}
        disabled={disabled}
        type={htmlType}
        className={cn(styles.button, styles[type], styles[size])}
        data-test-id={`${dataTestId}-main-button`}
        onClick={onClick}
      >
        {children}
      </button>
      <Dropdown
        items={items}
        align="right"
        shown={isExpanded}
        className={styles[`dropdown-${dropdownWidth}`]}
        flyoutClassName={styles.flyout}
        onOutsideClick={() => setIsDropdownShown(false)}
      >
        <button
          type="button"
          disabled={disabled}
          className={cn(styles["drop-button"], styles[type], styles[size])}
          data-test-id={`${dataTestId}-drop-button`}
          onClick={handleDropButtonClick}
        >
          <ChevronDownIcon
            className={cn(styles.chevron, {
              [styles.expanded]: isExpanded,
            })}
          />
        </button>
      </Dropdown>
    </div>
  );
};
